export enum EntityType {
    INSURER = 'INSURER'
}

export enum Status {
    REJECTED = "REJECTED",
    RECEIVED = "RECEIVED",
    REQUESTED = "REQUESTED",
    OPEN = "OPEN",
    ADDED = "ADDED",
    MORE_INFO_REQUESTED = "MORE_INFO_REQUESTED",
    SUBMITTED = "SUBMITTED",
    INPROGRESS = "INPROGRESS",
    ACTIVE = "ACTIVE",
    DEACTIVE = "DEACTIVE",
}

export enum ConfirmationMode {
    ADD = 'ADD',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    UPLOAD = 'UPLOAD'
}

